export enum RateType {
  shipper = 'embarcador',
  stop = 'destino'
}
